import { Col, Row, Text, TitledText } from '@/components';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RelatedMaterialFormDrawer } from './RelatedMaterialFormDrawer';

export const RelatedMaterialsInformation: FC = () => {
  const { id } = useId();
  const { t } = useTranslation();
  const project = useProject(id);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Text variant="h4" text={t('evaluasi-mandiri-oleh-pemerintah')} />
        </Col>

        <Col span={12}>
          <TitledText
            title={t('evaluation-of-program-results')}
            text={project.data?.indonesiaData?.evaluationOfProgramResults}
          />
        </Col>
        <Col span={12}>
          <TitledText
            title={t('improvement-suggestions')}
            text={project.data?.indonesiaData?.usulanPerbaikan}
          />
        </Col>
        <Col span={24}>
          <Text variant="h4" text={t('referensi-program-serupa')} />
        </Col>
        <Col span={12}>
          <TitledText
            title={t('related-program-for-other-ministry')}
            text={
              project.data?.indonesiaData?.referensiProgramYangSamaDiDaerahLain
            }
          />
        </Col>
        <Col span={12}>
          <TitledText
            title={t('catatan')}
            text={project.data?.indonesiaData?.catatan}
          />
        </Col>
      </Row>
      <RelatedMaterialFormDrawer />
    </>
  );
};
